module.exports = __webpack_public_path__ + "static/media/trondelag.e499187f.jpg";